import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect';
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import engine from 'store/src/store-engine';
import sessionStorages from 'store/storages/sessionStorage';
import plugins from 'store/plugins/expire';
import { AesEncrypt, AesDecode } from './js';

const sessionStore = engine.createStore(sessionStorages, plugins);

export const AUTH_LOGIN_DOING = 'AUTH_LOGIN_DOING';
export const AUTH_LOGIN_DONE = 'AUTH_LOGIN_DONE';
export const AUTH_LOGIN_ERR = 'AUTH_LOGIN_ERR';
export const AUTH_LOGOUT_DONE = 'AUTH_LOGOUT_DONE';

const locationHelper = locationHelperBuilder({});

export const userIsAuthenticatedRedir = redirectPath => connectedRouterRedirect({
  // A nice display name for this check
  wrapperDisplayName: 'UserIsAuthenticated',
  // The url to redirect user to if they fail
  redirectPath,
  // Determine if the user is authenticated or not
  authenticatedSelector: state => state.get('auth').status === 'LOGIN',
  // Returns true if the user auth state is loading
  //    authenticatingSelector: state => state.user.isLoading,
  // Render this component when the authenticatingSelector returns true
  //    AuthenticatingComponent: LoadingSpinner,
  allowRedirectBack: true,
});

export const userIsNotAuthenticatedRedir = redirectPath => connectedRouterRedirect({
  wrapperDisplayName: 'UserIsNotAuthenticated',
  redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || redirectPath,
  // This prevents us from adding the query parameter when we send the user away from the login page
  allowRedirectBack: false,
  authenticatedSelector: state => state.get('auth').status !== 'LOGIN',
});

const authStr = sessionStore.get('auth');
let emailStr;
let tokenStr;
if (authStr) {
  const authObject = JSON.parse(AesDecode(authStr));
  if (authObject) {
    const {
      email, token, sipDomain, kamDomain, deviceLen,
    } = authObject;
    emailStr = email;
    tokenStr = token;
    window.sipDomain = sipDomain;
    window.newSipDomain = kamDomain;
    window.oldDeviceLength = deviceLen;
  }
}
export const initialState = {
  status: tokenStr ? 'LOGIN' : 'LOGOUT',
  email: emailStr || '',
  token: tokenStr || '',
};

export function authReducer(state = initialState, action) {
  console.log('action.type:', action.type);
  let res = state;
  switch (action.type) {
    case AUTH_LOGIN_DOING:
      res.status = 'LOGGING';
      return res;
    case AUTH_LOGIN_DONE: {
      const authObj = {
        email: action.payload.email,
        token: action.payload.token,
        sipDomain: action.payload.sipDomain,
        kamDomain: action.payload.kamDomain,
        deviceLen: action.payload.deviceLen,
      };
      const authInfo = JSON.stringify(authObj);
      sessionStore.set('auth', AesEncrypt(authInfo));
      return {
        status: 'LOGIN',
        email: action.payload.email,
        token: action.payload.token,
      };
    }
    case AUTH_LOGIN_ERR:
      sessionStore.remove('auth');
      sessionStore.remove('ciamCode');
      res = {
        status: 'LOGOUT',
        email: '',
        token: '',
      };
      return res;
    case AUTH_LOGOUT_DONE:
      console.log('test is come auth-logout-done!!!');
      sessionStore.remove('auth');
      sessionStore.remove('ciamCode');
      res = {
        status: 'LOGOUT',
        email: '',
        token: '',
      };
      return res;
    default:
      return res;
  }
}
